import React from "react";
import { Box } from '@mui/material';
import PageTitle from '../../../components/Structure/Title/PageTitle';
import ClinicalTabs from '../components/ClinicalTabs';

const ClinicalInfoPage = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Header container: Title */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <PageTitle translationKey="ClinicalInfo.ClinicalInfo" />
      </Box>

      <ClinicalTabs />
    </Box>
  );
};

export default ClinicalInfoPage;
